/* Self-contained so the block behaves the same on all four concepts, including
   the one with no reveal observer of its own. Written to survive the Shopify
   build, which strips scripts out of the body and concatenates them into one
   asset file — so no document.currentScript, and no assumption about when it
   runs relative to the markup. */
(function(){
  document.documentElement.classList.add('ch-js');
  function start(){
    var els = [].slice.call(document.querySelectorAll('.ch'));
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {threshold:0.15});
    els.forEach(function(el){ io.observe(el); });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ============================================================
   Non-module layer: everything that must work with or without WebGL.
   ============================================================ */
(function(){
  var $  = function(s,r){return (r||document).querySelector(s);};
  var $$ = function(s,r){return [].slice.call((r||document).querySelectorAll(s));};
  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.__onyx = {};

  $('#yr').textContent = new Date().getFullYear();

  /* ---------- nav ---------- */
  var nav = $('#nav');
  addEventListener('scroll', function(){ nav.classList.toggle('stuck', scrollY > 40); }, {passive:true});

  /* ---------- accent: one place that owns the live colour ---------- */
  var root = document.documentElement;
  function setAccent(acc, deep){
    root.style.setProperty('--acc', acc);
    root.style.setProperty('--acc-deep', deep);
    if(window.__onyx.setLightColour) window.__onyx.setLightColour(acc);
  }

  /* ---------- full-range grid, built from the same slide data ----------
     The switch is gone: the two businesses are now signalled by colour and by
     their own CTAs, not by a mode the visitor has to set. */
  function buildGrid(){
    var g = $('#allgrid');
    if(!g) return;
    while(g.firstChild) g.removeChild(g.firstChild);
    $$('.slide').forEach(function(s, i){
      var t = document.createElement('div');
      t.className = 'tile';
      t.style.setProperty('--tc', s.getAttribute('data-deep'));

      var shot = document.createElement('div'); shot.className = 'shot';
      var ph = document.createElement('span'); ph.className = 'ph'; ph.textContent = 'RENDERING…';
      var img = document.createElement('img');
      var name = $('.pname', s) ? $('.pname', s).textContent : 'Screen';
      img.alt = name + ' — 3D render';
      shot.appendChild(ph); shot.appendChild(img);
      var src = window.__onyx.thumbSrcs && window.__onyx.thumbSrcs[i];
      if(src){ img.src = src; shot.removeChild(ph); }
      else { img.style.display = 'none'; }

      var h = document.createElement('h4'); h.textContent = name;
      var m = document.createElement('div'); m.className = 'meta';
      m.textContent = $('[data-kind]', s) ? $('[data-kind]', s).textContent : '';
      var p = document.createElement('div'); p.className = 'price';
      p.textContent = s.getAttribute('data-side') === 'ad' ? 'Booked by placement' : 'Price on enquiry';

      t.appendChild(shot); t.appendChild(h); t.appendChild(m); t.appendChild(p);
      g.appendChild(t);
    });
  }
  window.__onyx.paintThumbs = function(srcs){
    window.__onyx.thumbSrcs = srcs;
    $$('#allgrid .shot').forEach(function(shot, i){
      var img = $('img', shot), ph = $('.ph', shot);
      if(img && srcs[i]){ img.src = srcs[i]; img.style.display = ''; }
      if(ph) ph.remove();
    });
  };

  /* ---------- ticks ---------- */
  var ticks = $('#ticks');
  $$('.slide').forEach(function(){ ticks.appendChild(document.createElement('span')); });

  /* ---------- hero scroll driver ----------
     The hero is the only scroll-driven section left. Nothing below it is animated
     by scroll position, and nothing below it touches the 3D layer. */
  var slides = $$('.slide');
  var rangeSec = $('#range');
  var cur = -1;
  function progress(sec){
    var r = sec.getBoundingClientRect();
    var travel = sec.offsetHeight - innerHeight;
    if(travel <= 0) return 0;
    return Math.min(Math.max(-r.top / travel, 0), 1);
  }
  function onScroll(){
    if(root.classList.contains('nofx')) return;

    var p = progress(rangeSec);
    var i = Math.min(slides.length - 1, Math.floor(p * slides.length));
    if(i !== cur){
      cur = i;
      slides.forEach(function(s,n){ s.classList.toggle('on', n === i); });
      $$('#ticks span').forEach(function(t,n){ t.classList.toggle('on', n === i); });
      var cr = (slides[i].getAttribute('data-creative') || 'Family|days out').split('|');
      if(window.__onyx.setCreative) window.__onyx.setCreative(cr[0], cr[1], slides[i].getAttribute('data-acc'));
      if(window.__onyx.setUnit) window.__onyx.setUnit(i);
      setAccent(slides[i].getAttribute('data-acc'), slides[i].getAttribute('data-deep'));
      $('#counter').textContent = String(i+1).padStart(2,'0') + ' / ' + String(slides.length).padStart(2,'0');
    }
    $('#fill').style.width = (p*100).toFixed(2) + '%';

    if(window.__onyx.onScroll) window.__onyx.onScroll({range: p});
  }
  addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', onScroll);

  /* ---------- marquee: duplicated once so the -50% loop is seamless ---------- */
  (function(){
    var track = $('#mtrack');
    if(!track) return;
    var ITEMS = ['Cinemas','Soft play','Family entertainment centres','Bowling alleys',
                 'Farm parks','Shopping centres','Retail parks','High streets',
                 'Private clinics','Dental practices','Wellbeing centres','Hotels',
                 'Resorts','Corporate offices','Residential complexes'];
    for(var copy = 0; copy < 2; copy++){
      var g = document.createElement('div');
      g.className = 'mgroup';
      ITEMS.forEach(function(t){
        var sp = document.createElement('span'); sp.textContent = t;
        var dot = document.createElement('i');
        g.appendChild(sp); g.appendChild(dot);
      });
      track.appendChild(g);
    }
  })();

  /* ---------- reveals ---------- */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.12});
    $$('.rev').forEach(function(el){ io.observe(el); });
    /* the chain diagram carries its own observer — see chain.py */
  } else { $$('.rev').forEach(function(el){ el.classList.add('in'); }); }

  /* ---------- form ---------- */
  $('#enquiry').addEventListener('submit', function(e){
    e.preventDefault();
    $('#formnote').textContent = 'Prototype only — nothing was sent.';
  });

  /* ---------- mobile menu ---------- */
  $('#navtoggle').addEventListener('click', function(){
    var open = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', String(!open));
    $('.nav .links').style.display = open ? '' : 'flex';
    $('.nav').style.flexWrap = open ? '' : 'wrap';
  });

  /* ---------- fallback path ---------- */
  window.__onyx.fallback = function(reason){
    root.classList.add('nofx');
    $('#loader').classList.add('done');
    slides.forEach(function(s){ s.classList.add('on'); });
    $$('.rev').forEach(function(el){ el.classList.add('in'); });
    var ch = $('.ch'); if(ch) ch.classList.add('in');
    /* No renderer means no thumbnails are ever coming — don't leave five tiles
       saying "RENDERING…". The tinted tile on its own is a fine still. */
    $$('#allgrid .shot').forEach(function(shot){
      var ph = $('.ph', shot);
      if(ph) ph.remove();
    });
    if(reason) console.info('ONYX 3D disabled:', reason);

    /* Opened by double-clicking the file: the browser blocks the .glb fetch on a
       file:// origin, so the 3D can never start. Say so rather than quietly
       serving a flat page and letting it look like the build is broken. */
    if(location.protocol === 'file:') showFileNotice();
  };

  function showFileNotice(){
    if($('.notice')) return;
    var n = document.createElement('div');
    n.className = 'notice';
    var b = document.createElement('b');
    b.textContent = '3D is off because this page was opened as a file.';
    var t = document.createElement('span');
    t.textContent = 'Browsers block the model download on file:// — run it from a local server instead:';
    var c = document.createElement('code');
    c.textContent = 'python3 -m http.server 3456';
    var t2 = document.createElement('span');
    t2.textContent = 'then open localhost:3456/direction-onyx.html';
    var x = document.createElement('button');
    x.textContent = 'Dismiss';
    x.addEventListener('click', function(){ n.remove(); });
    [b, t, c, t2, x].forEach(function(el){ n.appendChild(el); });
    document.body.appendChild(n);
  }
  window.__onyx.showFileNotice = showFileNotice;
  /* The first tick runs before the 3D module exists, so slide 01 never pushes its
     creative to the panel. The 3D layer calls this once it's ready. */
  window.__onyx.refreshSlide = function(){ cur = -1; onScroll(); };
  window.__onyx.setAccent = setAccent;
  window.__onyx.onScrollTick = onScroll;
  window.__onyx.REDUCED = REDUCED;

  buildGrid();
  onScroll();
})();
